export const translations = {
  ARIA_LABEL_NAMESPACE: 'ariaLabels',
  IMAGE_ZOOM_ARIA_LABEL_KEY: 'GalleryItem_AriaLabel_ZoomImageButton',
  IMAGE_ZOOM_ARIA_LABEL_DEFAULT: 'press to zoom',
};
